const defaultDashboardTaskList = {
	timesheetsNeedingApproval: {
		team: true,
		weekly: true,
	},
	missedPunches: {
		summary: true,
	},
	requestsToReview: {
		schedule: true,
		pto: true,
		clock: true,
		availability: true,
		timesheet: true,
	},
	overtime: {
		summary: true,
	},
	mealViolations: {
		team: true,
	},
	clockExceptions: {
		total: true,
		cameEarly: true,
		cameLate: true,
		leftEarly: true,
		leftLate: true,
		notClocked: true,
		notScheduled: true,
		longBreak: true,
		shortBreak: true,
	},
};

export const mergeTaskListConfigWithDefaults = (config = {}) => {
	return Object.entries(defaultDashboardTaskList).reduce((result, [section, defaults]) => {
		const values = config?.[section];
		result[section] = Object.keys(defaults).reduce((items, key) => {
			items[key] = typeof values?.[key] === "boolean" ? values[key] : defaults[key];
			return items;
		}, {});
		return result;
	}, {});
};

export const isTaskListSectionVisible = (section) => Object.values(section).some(Boolean);
